import React from 'react';
import StoreProductWrapper from '../../../../views/store/product/StoreProductWrapper/StoreProductWrapper';
import { useCategoriesData } from '../../../../common/utils/utils';
import { getDefaultStaticProps, getLangPaths } from '../../../api/_props';
import Language from '../../../../common/decorators/Language';
import { getData } from '../../../../common/utils/router';
import moment from 'moment/moment';
import Loader from '../../../../widgets/plug/Loader/Loader';
import { tabsList } from '../../../../views/store/product/ProductMain/helpers';
import NotFound from '../../../../views/error/components/notFound';
import { getLangLocaleConnect } from '../../../../common/utils/api';
const project = require('../../../../scripts/configs/project');

const StoreProduct = ({ notFound, productItem, translates, categoriesData, categoriesMeta, reviews, tab }) => {
    const { categories, loadMoreCategories } = useCategoriesData(categoriesData, categoriesMeta);

    if (!productItem) {
        return <Loader />;
    }
    if (notFound) {
        return <NotFound translates={translates} />;
    }
    return (
        <Language translates={translates} page={'/store'}>
            <StoreProductWrapper
                tab={tab}
                reviews={reviews}
                translates={translates}
                categories={categories}
                loadMoreCategories={loadMoreCategories}
                product={productItem}
            />
        </Language>
    );
};
export async function getStaticProps({ params }) {
    const [product, tab] = params?.data || [];
    const defaultProps = await getDefaultStaticProps(params?.lang, `/store/product/${params?.data.join('/')}`, ['/store', '/']);
    if (!defaultProps?.props) {
        return defaultProps;
    }
    const { lang, currency } = defaultProps?.props;

    const productItem = await getData(
        `/api/v1/shop/products/${product}?breadcrumbs=true`,
        false,
        lang,
        moment().format('1DD.ss.2MM.3mm'),
        currency
    );
    if (!productItem?.data) {
        return { notFound: true };
    }

    const categories = await getData(
        '/api/v1/shop/product-categories?filter[parent_id]=0&page[size]=15&include=media',
        false,
        lang,
        moment().format('1DD.ss.2MM.3mm'),
        currency
    );
    const reviews =
        productItem?.data.links?.reviews && (!tab || tab === 'reviews')
            ? await getData(
                  `${productItem?.data.links?.reviews}?page[size]=${!tab ? 2 : 25}`,
                  false,
                  lang,
                  moment().format('1DD.ss.2MM.3mm'),
                  currency
              )
            : {};

    let notFound = false;
    let translates = defaultProps?.props?.translates || {};
    if (tab === 'properties' && !productItem?.data?.properties?.length) {
        const altTranslates = await getLangLocaleConnect({ page: { $in: ['all', '/', '/error'] } }, lang);
        translates = altTranslates?.data || {};
        notFound = true;
    }
    return {
        props: {
            ...defaultProps.props,
            categoriesData: categories?.data || [],
            categoriesMeta: { ...(categories?.meta || {}), ...(categories?.links || {}) },
            productItem: productItem?.data || {},
            reviews,
            currency: currency || null,
            tab: tab || 'all',
            translates,
            notFound
        },
        revalidate: project?.revalidate
    };
}
export async function getStaticPaths() {
    const paths = [];
    const langs = await getLangPaths();
    const product = await getData('/api/v1/shop/products?page[size]=999', false, false, moment().format('1DD.ss.2MM.3mm'));
    langs.forEach((lang) => {
        product?.data?.forEach((prod) => {
            paths.push({
                ...lang,
                params: { ...lang.params, data: [`${prod.id}`] }
            });
            tabsList
                .filter((tab) => tab !== 'all')
                .forEach((tab) => {
                    paths.push({
                        ...lang,
                        params: { ...lang.params, data: [`${prod.id}`, tab] }
                    });
                });
        });
    });
    return {
        paths,
        fallback: true
    };
}

export default StoreProduct;
